import { useQuery } from '@tanstack/react-query';

import { GetSuppliersParams } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useSupplierList = (params: GetSuppliersParams) => {
    return useQuery(queries.suppliers.list(params));
};
